module.exports = __webpack_public_path__ + "static/media/guide_img1_1_m.ce88deaf.png";